<template>
  <div class="footer">
    <div class="footer-top clearfix">
      <div class="footer-left fl">
        <img src="../assets/img/logo2.png" class="footer-logo" alt="">
      </div>
      <div class="footer-middle fl">
        <a href="http://www.zhixinhuixue.com">
          <p class="text">
            <span class="highlight-border">公司</span>官网
          </p>
          <p class="website">www.zhixinhuixue.com</p>
          <a class="block" :href="`${baseUrl}agreement.html`" target="_blank">软件使用协议</a>
          <a class="block" :href="`${baseUrl}version.html`" target="_blank">版权声明</a>
        </a>
      </div>
      <div class="footer-right fl">
        <p><span class="highlight-border">友情</span>链接：</p>
        <a href="http://www.fxbjy.com/index">江西风向标智能科技有限公司</a>
<!--        <a href="http://www.jtyjy.com ">金太阳教育官网</a>-->
<!--        <a href="http://www.jtyhjy.com/edu/home_index.action">好教育云平台</a>-->
      </div>
    </div>

    <div class="footer-bottom">
      <div class="company clearfix">
        <span class="fl">©{{getYear}} 江西风向标智能科技有限公司 All Rights Reserved</span>

        <a class="lg-c fr" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36010602000036"
           target="_blank">赣公网安备36010602000036号</a>
        <a href="http://beian.miit.gov.cn/" target="_blank" style="margin-right: 30px" class="fr">赣ICP备17000955号-3 </a>

        <router-link class="fr" to="/licence" style="margin-right: 30px">增值电信业务经营许可证：赣B2-20200065</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        baseUrl:process.env.NODE_ENV==='production'?'https://www.zhixinhuixue.com/copyRight/':'http://zsy.dev.xueping.com/copyRight/'
      }
    },
    computed: {
      //获取年份
      getYear() {
        return new Date().getFullYear();
      },
    },
    beforeMount(){
      console.log(process.env.NODE_ENV)
    }
  }
</script>

<style scoped lang="less">
  .highlight-border {
    border-bottom: 2px solid #3ECDBAFF;
  }

  .footer {
    background-color: #2a2f34;
    .block{
      display: block;
      color: #fff;
      text-decoration: underline;
      line-height: 28px;
      font-size: 14px;
    }
    .footer-top {
      width: 1200px;
      margin: 0 auto;
      height: 180px;
      /*display: flex;*/
      /*flex: 1;*/
      /*justify-content: center;*/
      /*align-items: center;*/

      .footer-left {
        width: 400px;
        height: 180px;

        .footer-logo {
          display: block;
          margin-top: 40px;
        }
      }

      .footer-middle {
        width: 400px;
        height: 180px;
        padding-top: 40px;
        box-sizing: border-box;

        .text {
          line-height: 30px;
          font-size: 18px;
          color: #fff;
        }

        .website {
          margin-top: 10px;
          line-height: 28px;
          color: #fff;
        }
      }

      .footer-right {
        width: 400px;
        height: 180px;
        padding-top: 40px;
        box-sizing: border-box;

        p {
          margin-bottom: 5px;
          line-height: 30px;
          font-size: 18px;
          color: #fff;
        }

        a {
          display: block;
          line-height: 28px;
          color: #fff;
          font-size: 14px;
          text-decoration: underline;
        }
      }

    }

    .footer-bottom {
      line-height: 60px;
      color: #BBBBBBFF;
      background-color: #101418FF;
      font-size: 14px;

      .company {
        width: 1200px;
        margin: 0 auto;

        a {
          color: #BBBBBBFF;
        }

        .lg-c {
          padding-left: 24px;
          margin-left: 10px;
          background: url("../assets/images/c.png") no-repeat 0;
          background-size: 20px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Footer.vue?d31f7e28